(function ($) {
    // Find headings, add anchors, add anchor links
    var anchorlinks = $(".anchorlinks")[0];
    var container = $(anchorlinks).parent();
    $(container).find(".mainbody h2, .linklist h2, .contactinfo h2").each(function (index, item) {

        var title = $(item).text().trim();
        var slug = title.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();

        $(item).attr("id", slug);
        if (title.length > 0) {
            $(".anchorlinks").append($("<li>").append($("<a>").attr("href", "#" + slug).html(title)));
        }
    });
    $(".landing-page .secondbody").find(".contentblock h2, .image-and-content-block h2").each(function (index, item) {

        var title = $(item).text().trim();
        var slug = title.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();

        $(item).attr("id", slug);
        if (title.length > 0) {
            $(".anchorlinks").append($("<li>").append($("<a>").attr("href", "#" + slug).html(title)));
        }
    });

    // Show browser print dialog on print link click
    $("a.print-link").click(function (e) {
        window.print();
        e.preventDefault();
    });

})(jQuery);